// extracted by mini-css-extract-plugin
export default {"main_page":"HyundaiCreta_main_page__Vyy6j","car_image":"HyundaiCreta_car_image__QqVU2"};